<template>
  <section>
    <dialog-component
      :dialogData="dialogData"
      :isShow="isShow"
      :isPlain="true"
      @cancel="isShow=false"
      @next="handleNext">
      <div class="email-dialog">
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div
            v-if="!isUnlink"
            class="form-block">
            <span>Old Email</span>
            <el-form-item>
              <v-input
                disabled
                :value="form.email"
              />
            </el-form-item>
          </div>
          <p
            v-else
            class="red-tip">
            After unlinking, this account will no longer share the same email and password with others. Please enter this account’s new email.
          </p>
          <div class="form-block">
            <span>New Email</span>
            <el-form-item
              ref="email"
              prop="email">
              <v-input
                v-model="formData.email"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
    </dialog-component>
    <email-dialog
      ref="email-dialog"
      :emailData="emailData"
      :isEdit="true"
      @continue="handleContinue"></email-dialog>
    <dialog-component
      :dialogData="errDialogData"
      :isShow="isClash"
      @cancel="handleClash"
      @next="isClash = false"
    >
      <div class="email-dialog">
        <p class="tip">
          This email is already used by another account,you cannot change a
          link account's email to one already used by another account.
        </p>
      </div>
    </dialog-component>
    <dialog-component
      :dialogData="editDialogData"
      :isShow="linkSent"
      :isUnitButton="true"
      :isPlain="true"
      :unitText="'OK'"
      @cancel="handleTipNext"
    >
      <div class="email-dialog">
        <p class="tip">
          {{tip}}
        </p>
      </div>
    </dialog-component>
  </section>
</template>

<script>
import emailDialog from './email-dialog'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {checkCompanyEmail,sendCompanyEmail} from '@/api/account'
import {checkEmail} from '@/utils/validate'

export default {
  name: 'enterEmailDialog',
  components:{
    emailDialog
  },
  mixins: [MixinOptions, MixinRules],
  props:{
    form:{
      type:Object,
      default:()=>({})
    },
    changeType:{
      type:Number,
      default:1
    },
    isUnlink:{
      type:Boolean,
      default:false
    },
    isChange:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      isShow:false,
      linkSent:false,
      isClash:false,
      formData:{
        email:''
      },
      emailData:{},
      extraRules:{
        email: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          { validator: checkEmail, trigger: ['change', 'blur'] },
        ],
      },
      isExist:true
    }
  },
  computed:{
    user_type(){
      let {user_type} = this.form||{}
      return user_type
    },
    errDialogData(){
      return{
        title:'Email Clash',
        buttonRightText:'Try Again'
      }
    },
    dialogData(){
      return{
        title:this.isUnlink?'Unlink Account':'Enter Login Email',
        buttonRightText:'Continue'
      }
    },
    editDialogData(){
      return{
        title:this.isUnlink&&!this.isExist?'Confirmation Email Sent':'Link Sent',
      }
    },
    tip(){
      let text = 'The email confirmation link has been sent. The account email will be edited when its link has been clicked.'
      if(this.isUnlink&&!this.isExist){
        text = 'An email confirmation and password reset link has been sent to the new email. The accounts will be unlinked when its link is clicked.'
      }
      return text
    }
  },
  methods:{
    handleTipNext(){
      this.linkSent=false
      this.isExist = true
      let {email} = this.formData||{}
      this.$emit('changeOk',email)
    },
    handleShow(){
      this.isShow = true
    },
    handleClash(){
      this.isClash = false
      this.isShow = false
      this.$emit('cancel')
    },
    handleNext(){
      this.$refs.form.validate((valid, rules) => {
        if (valid) {

          this.network().checkCompanyEmail()
        }
      })
    },
    handleContinue(){
      this.network().sendCompanyEmail()
    },
    network() {
      return {
        checkCompanyEmail: async ()=>{
          let {isrd_com_nm,user_type} = this.form||{}
          let {email} = this.formData||{}
          const { data } = await checkCompanyEmail({company_name:isrd_com_nm,email,user_type})
          let {existed} = data
          this.emailData = data
          this.isExist = existed
          if(this.isChange)
          {
            if(existed)
            {
              this.isClash = true
            }else{
              this.isShow = false
              this.network().sendCompanyEmail()
            }
          }
          else{
            this.isShow = false
            if(existed){
              this.$refs['email-dialog'].handleShow()
            }
            else{
              this.network().sendCompanyEmail()
            }
          }
        },
        sendCompanyEmail: async ()=>{
          let {email} = this.formData||{}
          let customer_id = this.$route.query.customer_id||''
          const { data } = await sendCompanyEmail({change_type:this.isUnlink?1:this.changeType,email,customer_id})
          this.linkSent = true
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .email-dialog{
    .form-block {
      margin-bottom: 15px;
      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        color: #616266;
        font-weight: bold;
        font-size: 14px;
      }
    }
    .red-tip{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #CB2431;
      margin-bottom: 20px;
    }
  }
</style>
